import * as echarts from 'echarts'
import { addListener } from 'resize-detector'
import 'leaflet'
import 'leaflet-polylineoffset'

/* eslint-disable */
export default {
  data () {
    return {
      mapExtraOptionsMix: null,
      seriesNameCounter: 0,
      registerMapCounter: 0,
      baseMapStyles: {
        borderColor: 'white',
        borderWidth: 1,
        choroplethColors: ['#00c0ef', '#3c8dbc', '#f66955', '#f39c11', '#00a65a'],
        areaColor: 'gray',
        defaultFill: 'gray',
        simpleFill: 'rgba(0, 0, 0, 0.3)'
      },
    }
  },
  methods: {
    createChartMap(blockId, chartData, mapExtraOptions) {
      let leafletMapData = {}
      let type = ''
      let _haveTiles = this.haveTileLayer(chartData.layers)
      this.mapExtraOptionsMix = mapExtraOptions
      if (!_haveTiles) { // если подложки нет, то конвертируем координаты
        var myChart = this.createEchartsMap(chartData, blockId)
        type = 'echarts'
        return {chart: myChart, typeMap: type}
      } else { // иначе делаем leaflet карту
        leafletMapData = this.createLeafletMap(chartData, blockId)
        type = 'leaflets'
        return {leafletMapData: leafletMapData, typeMap: type}
      }
    },

    createEchartsMap (chartData, blockId) {
      var myChart = echarts.init(document.getElementById(blockId)) // инициализируем график
      chartData = this.converLayersFromWgsToMercator(chartData) // конвертируем данные

      let option = this.createOptionsForMap(chartData, blockId) // генерируем options
      console.log(blockId)
      console.log(option)
      myChart.setOption(option)

      let zr = myChart.getZr()

      zr.on('click', e => {
        if (e.target == undefined) {
          this.destroyPopup()
        }
      })

      myChart.on('click', 'series', e => {
        let parent = null
        if (document.body.clientWidth > 768) {
          // console.log(e)
          // if (e.event.event.path !== undefined) {
          //   parent = e.event.event.path[1]  // условие для остальных браузеров
          // } else {
          //   parent = e.event.event.originalTarget // условие для Firefox
          // }
          parent = document.getElementById(blockId)
        } else {
          parent = document.body
        }
        let popup = this.createPopup(e, blockId)
        parent.appendChild(popup)

        let _sourceLayerIndex = 0
        _sourceLayerIndex = option.series.find(item => { return item.name === e.seriesName })
        // console.log(e)
        this.$emit('changeStyleButtonGoChild', {dataIndex: e.dataIndex, blockId: blockId, sourceLayerIndex: _sourceLayerIndex.sourceLayerIndex})

      })

      addListener(document.getElementById(blockId), () => {
        myChart.resize()
        myChart.dispatchAction({type: 'restore'})
      })
      return myChart
    },

    createOptionsForMap (response, blockId) {
      let _options = {
        series: []
      }

      for (let i = 0; i < response.layers.length; i++) {
        if (response.layers[i].type === 'wms') {
          continue
        }
    
        let _style = response.layers[i].style
        

        if (this.isTimelineMap(response)) {
          return this.addFieldsTimeline(_options, response.layers[i], blockId)
        }

        if (_style.type === 'simple') {
          _options = this.addFieldsSimpleType(_options, response.layers[i], i)
        } else if (_style.type === 'choropleth') {
          _options = this.addFieldsChoropleth(_options, response.layers[i], i)
        } else if (_style.type === 'classes') {
          _options = this.addFieldsClassesType(_options, response.layers[i], i)
        } else {
          console.error('unknwon style type ' + _style.type)
        }
        this.seriesNameCounter++
        this.registerMapCounter++
      }
    
      return _options
    },

    addFieldsSimpleType(options, layer, sourceLayerIndex) {
      // options.itemStyle = {
      //   areaColor: 'fill' in style ? style.fill : "gray",
      //   borderColor: 'border' in style && 'color' in style.border ? style.border.color : 'white',
      //   borderWidth: 'border' in style && 'width' in style.border ? style.border.width : 1
      // }
      let _ser = this.createEmptySeries(layer)
      _ser.data = this.createDataSimple(layer)
      _ser.z = -100
      _ser.zlevel = -100
      _ser.roam = true
      _ser.sourceLayerIndex = sourceLayerIndex
    
      options.series.push(_ser)
    
      echarts.registerMap('map_name_' + this.registerMapCounter, layer.features)
      _ser.map = 'map_name_' + this.registerMapCounter
    
      return options
    },

    createDataSimple (layer) {
      let _data = []
      layer.features.features.forEach(item => {
        _data.push({
          name: item.properties[layer.title_column],
          value: [item.properties[layer.value_column]]
        })
      })
      return _data
    },

    addFieldsChoropleth (options, layer, sourceLayerIndex) {
      let _ser = this.createEmptySeries(layer)
      let _dataCropeth = this.makeDataChoropleth(layer)
      _ser.data = _dataCropeth.data
      _ser.sourceLayerIndex = sourceLayerIndex
      console.log(layer)
      echarts.registerMap('map_name_' + this.registerMapCounter, layer.features)
      _ser.map = 'map_name_' + this.registerMapCounter

      options.visualMap = {
        // type: 'piecewise',
        // show: showVisualMap !== undefined ? showVisualMap : true,
        left: 'right',
        min: ('min_value' in layer.style) && (layer.style.min_value !== null && layer.style.min_value !== 'undefined') ? layer.style.min_value : _dataCropeth.minMax.min,
        max: ('max_value' in layer.style) && (layer.style.max_value !== null && layer.style.max_value !== 'undefined') ? layer.style.max_value : _dataCropeth.minMax.max,
        inRange: {
          color: this.getChoroplethColors(layer.style)
        },
        outOfRange: {
          color: this.getDefaultFill(layer.style)
        },
        calculable: true
      }

      options.series.push(_ser)
      return options
    },

    makeDataChoropleth (layer) { // возвращает массив данных в формате для echarts, а также min и max значение
      let valueColumn = layer.value_column
      let titleColumn = this.getNameProperty(layer)
      let data = []
      let minMax = {
        min: null,
        max: null
      }
      let featureValue = null
      let _defailt_fill = this.getDefaultFill(layer.style)
      
      for (let i = 0; i < layer.features.features.length; i++) {
        featureValue = layer.features.features[i].properties[valueColumn]
        if (featureValue !== null && featureValue !== 'null') { // если не null
          featureValue = Number(featureValue)
          data.push({
            name: layer.features.features[i].properties[titleColumn],
            value: featureValue
          })
        } else { // если null
          data.push({
            name: layer.features.features[i].properties[titleColumn],
            value: featureValue,
            itemStyle: {
              areaColor: _defailt_fill
            }
          })
        }
        if (minMax.min > featureValue || minMax.min === null) {
          minMax.min = featureValue
        }
        if (minMax.max < featureValue || minMax.max === null) {
          minMax.max = featureValue
        }
      }
      return { data: data, minMax: minMax }
    },

    addFieldsClassesType (options, layer, sourceLayerIndex) {
      let _ser = this.createEmptySeries(layer)
      _ser.data = this.makeDataByClasses(layer)
      _ser.sourceLayerIndex = sourceLayerIndex
    
      options.visualMap = {
        type: 'piecewise',
        categories: layer.style.classes.map(item => {return item.title}), // TODO выводить только классы, которые используются(не только тут, но и в остальных графиках echarts)
        left: 'right',
        inRange: {
          color: this.getChoroplethColors(layer.style)
        },
        outOfRange: {
          color: this.getDefaultFill(layer.style)
        }
      }

      options.series.push(_ser)
    
      echarts.registerMap('map_name_' + this.registerMapCounter, layer.features)
      _ser.map = 'map_name_' + this.registerMapCounter
    
      return options
    },

    makeDataByClasses (layerData) {
      let _titleColumn = layerData.title_column
      // let _titleColumn = 'name'
      let _classColumn = layerData.style.class_column
    
      let _data = []
      let itemClass = null
      for (let i = 0; i < layerData.features.features.length; i++) {
        itemClass = layerData.features.features[i].properties[_classColumn]
        for (let j = 0; j < layerData.style.classes.length; j++) {
          if (itemClass === layerData.style.classes[j].value) {
            _data.push({
              name: layerData.features.features[i].properties[_titleColumn],
              value: [i, layerData.style.classes[j].title], // любое значние(не используется) и класс
            })
          }
        }
      }

      return _data
    },

    haveTileLayer (layers) {
      try {
        let _layer = layers.find(function (item) { return item.type === 'image' || item.type === 'basemap' })
        let _url = _layer !== undefined ? _layer.url : null
        if (_url !== undefined && _url !== null && _url !== '' && _url !== 'null') {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error('fail get tile layer url')
        return false
      }
    },
    
    getTileUrl (layer) {
      if ('url' in layer) {
        return layer.url
      } else {
        return null
      }
    },

    converLayersFromWgsToMercator (response) {
      let _convertedResponse = JSON.parse(JSON.stringify(response))
      for (let i = 0; i < _convertedResponse.layers.length; i++) {
        if (_convertedResponse.layers[i].type === 'features') {
          _convertedResponse.layers[i].features = this.convertLayerWgsToMercator(_convertedResponse.layers[i].features)
        }
      }
      return _convertedResponse
    },

    convertLayerWgsToMercator (originalLayer) {
      let layer = JSON.parse(JSON.stringify(originalLayer))
      for (let i = 0; i < layer.features.length; i++) {
        if (layer.features[i].geometry.type === 'MultiPolygon') {
          for (let j = 0; j < layer.features[i].geometry.coordinates.length; j++) {
            for (let ij = 0; ij < layer.features[i].geometry.coordinates[j].length; ij++) {
              layer.features[i].geometry.coordinates[j][ij] = layer.features[i].geometry.coordinates[j][ij].map(item => {
                return this.WGStoMercator(item)
              })
            }
          }
        } else if (layer.features[i].geometry.type === 'Polygon') {
          for (let j = 0; j < layer.features[i].geometry.coordinates.length; j++) {
            layer.features[i].geometry.coordinates[j] = layer.features[i].geometry.coordinates[j].map(item => {
              return this.WGStoMercator(item)
            })
          }
        } else if (layer.features[i].geometry.type === 'Point') {
          layer.features[i].geometry.coordinates = this.WGStoMercator(layer.features[i].geometry.coordinates)
        } else {
          console.error('fail conver wgs to mercator')
        }
      }
      return layer
    },
    
    WGStoMercator(coords) {
      // console.log('old', coords)
      let x = coords[0] * 20037508.34 / 180
      let y = Math.log(Math.tan((90 + coords[1]) * Math.PI / 360)) / (Math.PI / 180)
      y = y * 20037508.34 / 180
      // console.log('new', [x, y])
      return [x, y]
    },

    isTimelineMap (responseData) { 
      for (let i = 0; i < responseData.layers.length; i++) {
          if (('timeline' in responseData.layers[i])  && responseData.layers[i].type === 'timeline') {
          return true
        }
      }
      return false
    },

    addFieldsTimeline (defaultOptions, geoData, blockId) {
      let datesAndSeriesFromTimeline = this.getDatesAndSeriesFromTimeline(geoData, geoData.features.features)
      console.log(geoData)
      defaultOptions.timeline = {
        axisType: 'category',
        autoPlay: false,
        playInterval: 700,
        data: datesAndSeriesFromTimeline.dates
      }
      defaultOptions.visualMap = {
        min: ('min_value' in geoData.style) && (geoData.style.min_value !== null && geoData.style.min_value !== 'undefined') ? geoData.style.min_value : datesAndSeriesFromTimeline.minValue,
        max: ('max_value' in geoData.style) && (geoData.style.max_value !== null && geoData.style.max_value !== 'undefined') ? geoData.style.max_value : datesAndSeriesFromTimeline.maxValue,
        realtime: false,
        calculable: true,
        inRange: {
          color: this.getChoroplethColors(geoData.style)
        },
        outOfRange: {
          color: this.getDefaultFill(geoData.style)
        }
      }

      let _ser = this.createEmptySeries(geoData)

      defaultOptions.series = [{
        type: 'map',
        mapType: 'map_name_' + blockId + '_' + this.registerMapCounter,
        aspectScale: 0.6,
        itemStyle: _ser.itemStyle
      }]

      let _newOption = {
        baseOption: defaultOptions,
        options: datesAndSeriesFromTimeline.series
      }

      echarts.registerMap('map_name_' + blockId  + '_' + this.registerMapCounter, geoData.features)

      return _newOption
    },

    getDatesAndSeriesFromTimeline (geoData, features) {
      let _dates = [],
          _series = [],
          _index = -1,
          _minValue = null,
          _maxValue = null,
          _valueColumn = [],
          _timeline = [],
          _titleColumn = this.getNameProperty(geoData)

      _timeline = geoData.timeline
      _valueColumn = geoData.value_column


      features.forEach(element => {
        for (let key in element.properties[_valueColumn]) {
          let _timelineIndex = _timeline.findIndex(item => {
            return item.value === key
          })


          _index = _dates.findIndex(item => {
            return _timeline[_timelineIndex].title === item
          })

          if (_index !== -1) { // индексы дат в _dates совпадают(обязаны совпадать) с индексами в _series
            _series[_index].series[0].data.push({
              name: element.properties[_titleColumn],
              value: element.properties[_valueColumn][key]
            })
          } else {
            _dates.push(_timeline[_timelineIndex].title)
            _series.push({
              series: [
                {
                  data: [
                    {
                      name: element.properties[_titleColumn],
                      value:element.properties[_valueColumn][key]
                    }
                  ]
                }
              ]
            })
          }

          if (element.properties[_valueColumn][key] !== null && element.properties[_valueColumn][key] !== 'null' && (Number(element.properties[_valueColumn][key]) > _maxValue)) { // поиск для наибольшего и наименьшего
            _maxValue = Number(element.properties[_valueColumn][key])
          }
          if (element.properties[_valueColumn][key] !== null && element.properties[_valueColumn][key] !== 'null' && (Number(element.properties[_valueColumn][key]) < _minValue)) {
            _minValue = Number(element.properties[_valueColumn][key])
          }
        }
        
      })

      return {dates: _dates, series: _series, minValue: _minValue, maxValue: _maxValue}
    },

    getCenterFromBbox (bbox) {
      try {
        if (bbox !== null && typeof bbox[0] === 'number') {
          return [ (bbox[0] + bbox[2]) / 2, ((bbox[1] + bbox[3]) / 2) ]
        } else {
          return [97.734375, 62.67414334669093]
        }
      } catch (error) {
        console.error('fail get center from bbox', error)
        return [97.734375, 62.67414334669093]
      }
    },

    getDefaultFill (style) {
      if (style !== undefined && 'default_fill' in style && style.default_fill !== undefined && style.default_fill !== null) {
        return style.default_fill
      } else {
        return this.baseMapStyles.default_fill
      }
    },

    getZoomFromBboxLeaflet (bbox) {
      if (bbox !== null && bbox !== undefined && typeof bbox[0] === 'number') {
        let _deltaX = Math.abs(bbox[2] - bbox[0])
        let _deltaY = Math.abs(bbox[3] - bbox[1])
        let _maxDelta = Math.max(_deltaX, _deltaY)
        let _zoom = 7
        let _xZoom = 7
        let _yZoom = 7
    
        if (_maxDelta < 0.007) {
          _zoom = 18
        } else if (_maxDelta < 0.14) {
          _zoom = 17
        } else if (_maxDelta < 0.28) {
          _zoom = 16
        } else if (_maxDelta < 0.55) {
          _zoom = 15
        } else if (_maxDelta < 0.11) {
          _zoom = 14
        } else if (_maxDelta < 0.23) {
          _zoom = 13
        } else if (_maxDelta < 0.45) {
          _zoom = 12
        } else if (_maxDelta < 0.9) {
          _zoom = 11
        } else if (_maxDelta < 1.8) {
          _zoom = 10
        } else if (_maxDelta < 3.6) {
          _zoom = 9
        } else if (_maxDelta < 7.1) {
          _zoom = 8
        } else if (_maxDelta < 14.2) {
          _zoom = 7
        } else if (_maxDelta < 28.5) {
          _zoom = 6
        } else if (_maxDelta < 56.9) {
          _zoom = 5
        } else if (_maxDelta < 113.7) {
          _zoom = 4
        } else if (_maxDelta < 228.3) {
          _zoom = 3
        } else {
          _zoom = 2
        }
        _xZoom = _zoom
    
        if (_maxDelta < 0.002) {
          _zoom = 18
        } else if (_maxDelta < 0.006) {
          _zoom = 17
        } else if (_maxDelta < 0.01) {
          _zoom = 16
        } else if (_maxDelta < 0.02) {
          _zoom = 15
        } else if (_maxDelta < 0.04) {
          _zoom = 14
        } else if (_maxDelta < 0.09) {
          _zoom = 13
        } else if (_maxDelta < 0.18) {
          _zoom = 12
        } else if (_maxDelta < 0.36) {
          _zoom = 11
        } else if (_maxDelta < 0.73) {
          _zoom = 10
        } else if (_maxDelta < 1.47) {
          _zoom = 9
        } else if (_maxDelta < 2.9) {
          _zoom = 8
        } else if (_maxDelta < 5.8) {
          _zoom = 7
        } else if (_maxDelta < 11.7) {
          _zoom = 6
        } else if (_maxDelta < 23.5) {
          _zoom = 5
        } else if (_maxDelta < 47.2) {
          _zoom = 4
        } else if (_maxDelta < 93.6) {
          _zoom = 3
        } else {
          _zoom = 2
        }
        _yZoom = _zoom

        if (_maxDelta < 1) {
          return Math.floor(((_xZoom * 0.75 + _yZoom * 1.1)) / 2) - 2
        } else {
          return Math.ceil(((_xZoom * 0.75 + _yZoom * 1.1)) / 2) - 2
        }
      } else {
        return 4
      }
    },

    getNameProperty (layer) {
      if ('title_column' in layer && layer.title_column !== undefined && layer.title_column !== null) {
        return layer.title_column
      } else {
        return 'name'
      }
    },

    getSeriesName (layer) {
      if ('features' in layer && 'name' in layer.features && layer.features.name !== undefined && layer.features.name !== null) {
        return layer.features.name
      } else {
        return 'series_name_' + this.seriesNameCounter
      }
    },

    getBorderColor (style) {
      if (style !== undefined && 'border' in style && 'color' in style.border && style.border.color !== undefined && style.border.color !== null) {
        return style.border.color
      } else {
        return this.baseMapStyles.borderColor
      }
    },

    getBorderWidth (style) {
      if (style !== undefined && 'border' in style && 'width' in style.border && style.border.width !== undefined && style.border.width !== null) {
        return style.border.width
      } else {
        return this.baseMapStyles.borderWidth
      }
    },

    getAreaColor (style) {
      if (style !== undefined && 'fill' in style) {
        return style.fill
      } else {
        return this.baseMapStyles.areaColor
      }
    },

    getChoroplethColors (style) {
      if (style !== undefined && 'fill' in style) {
        return style.fill
      } else {
        return this.baseMapStyles.choroplethColors
      }
    },

    getSimpleColor (style) {
      if (style !== undefined && 'fill' in style) {
        return style.fill
      } else {
        return this.baseMapStyles.simpleFill
      }
    },

    createEmptySeries (layer) {
      let _style = layer.style
      let _ser = {
        nameProperty: this.getNameProperty(layer),
        name: this.getSeriesName(layer),
        type: 'map',
        roam: this.mapExtraOptions && 'roam' in this.mapExtraOptionsMix ? this.mapExtraOptionsMix.roam : false,
        zoom: 1.1,
        scaleLimit: {
          min: 0.5,
          max: 5
        },
        aspectScale: 0.9,
        animation: false,
        // map: 'myMap_' + blockId,
        map: 'myMap_' + this.registerMapCounter,
        itemStyle: {
          borderColor: this.getBorderColor(_style),
          borderWidth: this.getBorderWidth(_style),
          color:'#000',
          // areaColor: "#fc817e",
          emphasis: {
            label: {
              formatter: function(params) {
                    // var name = params.dataIndex.toString();
                    // console.log('params', params)
                    let name = String(params.name);
                    name = name.split(' ').join('\n');
                    let value = 'data' in params && params.data !== undefined && 'value' in params.data ? params.data.value : null
                    if (value === null || value === 'null') {
                      value = '—'
                    }
                    return name + '\nЗначение: ' + value
                  },
              show: true,
              borderRadius: 3,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              padding: 10,
              fontWeight: 'bold'
            }
          }
        }
      }
      return _ser
    },
    
    setDefaultPositionLeaflet(chart, leafletMapData) {
      if (chart.bbox) {
        leafletMapData['leaflet'].fitBounds([ // выровнять по bbox
          [chart.bbox[1], chart.bbox[0]],
          [chart.bbox[3], chart.bbox[2]]
        ])
      } else {
        leafletMapData['leaflet'].setView(leafletMapData['center'], leafletMapData['zoom'])
      }
    },

    createLeafletMap (chart, blockId) {
      let _overlayLayersWithNames = []
      let _imageLayersWithNames = []
      let _baseLayersWithNames = []
      for (let i = 0; i < chart.layers.length; i++) { // добавляем слои
        if (chart.layers[i].type === 'basemap') {
          _baseLayersWithNames.push(this.addLeafTileLayer(chart.layers[i]))
        } else if (chart.layers[i].type === 'image') {
          _imageLayersWithNames.push(this.addLeafTileLayer(chart.layers[i]))
        } else if (chart.layers[i].type === 'features') {
          _overlayLayersWithNames = _overlayLayersWithNames.concat(this.createLeafFeaturesLayers(chart.layers[i], i, blockId))
        } else {
          console.error('unknown type layer ' + chart.layers[i].type)
        }
      }
    
      let leafletMapData = this.initLeafletMap(chart, blockId, _baseLayersWithNames, _overlayLayersWithNames, _imageLayersWithNames) // создаем карту
    
      leafletMapData['leaflet'].fitBounds([ // выровнять по bbox
        [chart.bbox[1], chart.bbox[0]],
        [chart.bbox[3], chart.bbox[2]]
      ])
      
      return leafletMapData
    },

    initLeafletMap (chart, blockId, baseLayersWithNames, overlayLayersWithNames, imageLayersWithNames) {
      let center = this.getCenterFromBbox(chart.bbox)
      let zoom = this.getZoomFromBboxLeaflet(chart.bbox)
    
      let _initLayers = null

      if (this.mapExtraOptionsMix !== undefined && this.mapExtraOptionsMix.baseLayerName !== undefined) { // если на превью поменяли базовый слой и его имя передалось
        let baseLayerIndex = baseLayersWithNames.findIndex(item => { // ищем индекс этого слоя
          return item.title === this.mapExtraOptionsMix.baseLayerName
        })
        // console.log('baseLayersWithNames', baseLayersWithNames)
        if (baseLayerIndex !== -1) { // если индекс найден, то выбираем найденный слой
          _initLayers = [baseLayersWithNames[baseLayerIndex].layer].concat(overlayLayersWithNames.map(item => {return item.layer}))
        } else { // если индекс не найден, то выбираем первый слой
          _initLayers = [baseLayersWithNames[0].layer].concat(overlayLayersWithNames.map(item => {return item.layer})) // отрисовать первую подложку из тех что с типом basemap, и все что были с типом features
        }
      } else { // если слой не передвали, то тоже берем первый
        _initLayers = [baseLayersWithNames[0].layer].concat(overlayLayersWithNames.map(item => {return item.layer})) // отрисовать первую подложку из тех что с типом basemap, и все что были с типом features
      }

      for (let i of imageLayersWithNames) {
        _initLayers = [i.layer].concat(_initLayers)
      }
      

      let leafMap = L.map(blockId, {
        center: center, // TODO если нет bbox то возвращать координаты первой фичи
        zoom: zoom,
        maxZoom: 15,
        minZoom: 4,
        maxBounds: [
          [84.26717240431665, 194.765625],
          [-45.82879925192133, -38.3203125]
        ],
        trackResize: true,
        layers: _initLayers
      })

      this.addLeafLayerController(leafMap, baseLayersWithNames, imageLayersWithNames)

      // this.addLeafLayerCheckbox(leafMap)
      
      this.addPointsBorder(leafMap, overlayLayersWithNames)
    
      this.createLeafCustomLegend(leafMap, overlayLayersWithNames, blockId)

      addListener(document.getElementById(blockId), () => { // изменение размеров карты, на извенение размеров контейнера
        leafMap.invalidateSize()
      })

      leafMap.on('click', e => { // убрать попап при клике просто в карту
        this.destroyPopup()
      })

      leafMap.on('baselayerchange', e => {
        this.$eventHub.$emit('change-base-layer', {blockId, blockId, layerName: e.name})
      })
    
      return {leaflet: leafMap, center: center, zoom: zoom}
    },

    addLeafTileLayer (layer) {
      let _tileUrl = this.getTileUrl(layer)
      if (_tileUrl !== null) {
        let _layer = L.tileLayer(_tileUrl, {
          attribution: layer.title
        })
        // }).addTo(leafMap)
        return {layer: _layer, title: layer.title}
      }
      return null
    },

    createLeafFeaturesLayers (layer, sourceLayerIndex, blockId) {
      if ('features' in layer && 'style' in layer) {
        let _features = layer.features
        let _classColumn = layer.style.class_column
        let _titleColumn = this.getNameProperty(layer)
    
        switch (layer.style.type) {
          case 'points':
            let layersByClassesPoints = this.splitFeaturesByClassesLeaf(_features, _classColumn, layer.style, sourceLayerIndex) // разбиваем геожсон по классам
            // далее присвоить стили, сделать слои леафлета
            let layersWithNamesPoints = [] // массив объектов в которых есть title, fillColor, type и layer(слой leaflet)
            layersByClassesPoints.forEach(element => {
              let _layer = L.geoJSON({ // теперь это слой laeflet
                features: element.geojson,
                type: "FeatureCollection",
              }, {
                pointToLayer: (feature, latlng) => { // точки обрабатываются по особому
                  return L.circleMarker(latlng, {
                      radius: 6,
                      fillColor: element.fill,
                      // color: this.getBorderColor(layer.style), // цвет границы
                      color: `url(#gradient-${blockId})`, // цвет границы
                      weight: this.getBorderWidth(layer.style), // толщина границы
                      // weight: 2,
                      fillOpacity: 1
                  })
                }, 
                onEachFeature: (feature, layer) => { // добавляем click leaflet
                  this.onEachFeatureFunction(feature, layer, blockId) // говоря по совести layer тут скорее feature с стилями leaflet
                  layer.on('mouseout', function (e) {
                    _layer.resetStyle()
                  })
                  this.addOnEachFeatureHoverStyle(feature, layer)
                }
              })
              this.addCustomTooltip(_layer, _titleColumn, element.fill, element.title)
              layersWithNamesPoints.push({layer: _layer, title: element.title, fillColor: element.fill, type: layer.style.type, borderColor: this.getBorderColor(layer.style), borderRuleName: `gradient-${blockId}`})
            })
          return layersWithNamesPoints
    
    
          case 'simple':
            let simpleBorderColor = this.getBorderColor(layer.style)
            let simpleFirstBorderColor = null
            let simpleSeconBorderColor = null
            if (Array.isArray(simpleBorderColor)) {
              simpleFirstBorderColor = simpleBorderColor[0]
              if (simpleBorderColor[1] !== undefined) {
                simpleSeconBorderColor = simpleBorderColor[1]
              }
            } else {
              simpleFirstBorderColor = simpleBorderColor
            }
            let _style = {
              fillColor: this.getAreaColor(layer.style), // цвет заливки(внутри полигона)
              color: simpleFirstBorderColor, // цвет border-а у полигона
              weight: (simpleSeconBorderColor === null) ? this.getBorderWidth(layer.style) : this.getBorderWidth(layer.style) / 2,
            }
            let _layerSimple = L.geoJSON(_features, {
              style: _style,
            })

            if (simpleSeconBorderColor !== null) { // если второй цвет есть, то делаем границы
              let _borderCoords = this.convertPolygonsToPolyline(_features.features) // добавляем границы к полоигонам(polyline-ы) // хз почему, но polyline нужны координаты наоборот(не [x, y], а [y, x])
              _borderCoords = _borderCoords.map(item => { // это должен быть не геожсон, а просто набор координат
                return item.geometry.coordinates
              })

              let polygonBorders = L.polyline(_borderCoords, {
                offset: this.getBorderWidth(layer.style) / 2, // отступ который обеспечивает leaflet-polylineoffset
                weight: this.getBorderWidth(layer.style) / 2,
                color: simpleSeconBorderColor,
                opacity: 1
              })

              _layerSimple = L.layerGroup([_layerSimple, polygonBorders]) // объединяем имеющийся слой и границы в группу, чтобы они включались и отключались вместе
            }
          return [{layer: _layerSimple, type: layer.style.type}]
        
          case 'polygons':
            // console.log('blockId', blockId)
            let layersByClasses = this.splitFeaturesByClassesLeaf(_features, _classColumn, layer.style, sourceLayerIndex) // разбиваем геожсон по классам
            let borderColor = this.getBorderColor(layer.style)
            let firstBorderColor = null
            let seconBorderColor = null
            if (Array.isArray(borderColor)) {
              firstBorderColor = borderColor[0]
              if (borderColor[1] !== undefined) {
                seconBorderColor = borderColor[1]
              }
            } else {
              firstBorderColor = borderColor
            }
              
    
            let layersWithNamesPolygons = [] // массив объектов в которых есть title, fillColor, type и layer(слой leaflet)
            layersByClasses.forEach(element => { // делаем leaflet слой
              let _layer = L.geoJSON({
                features: element.geojson,
                type: "FeatureCollection",
              }, {
                style: {
                  fillColor: element.fill,
                  color: firstBorderColor, // цвет границы
                  weight: (seconBorderColor === null) ? this.getBorderWidth(layer.style) : this.getBorderWidth(layer.style) / 2, // толщина границы. Делим пополам т.к. границы две
                  fillOpacity: 1,
                },
                onEachFeature: (feature, layer) => { // добавляем click leaflet
                  this.onEachFeatureFunction(feature, layer, blockId)
                  layer.on('mouseout', function (e) {
                    if (Object.keys(_layer._layers).length > 2) {
                      _layer.resetStyle()
                    } else {
                      for (let key in _layer._layers) { // найти нужный layer из группы
                        if ('_tooltip' in _layer._layers[key]) {
                          _layer._layers[key].resetStyle()
                        }
                      }
                    }
                  })
                  this.addOnEachFeatureHoverStyle(feature, layer)
                }
              })

              this.addCustomTooltip(_layer, _titleColumn, element.fill, element.title) // добавляем tooltip

              if (seconBorderColor !== null) { // если второй цвет есть, то делаем границы
                let _borderCoords = this.convertPolygonsToPolyline(element.geojson) // добавляем границы к полоигонам(polyline-ы) // хз почему, но polyline нужны координаты наоборот(не [x, y], а [y, x])
                _borderCoords = _borderCoords.map(item => { // это должен быть не геожсон, а просто набор координат
                  return item.geometry.coordinates
                })
  
                let polygonBorders = L.polyline(_borderCoords, {
                  offset: this.getBorderWidth(layer.style) / 2, // отступ который обеспечивает leaflet-polylineoffset
                  weight: this.getBorderWidth(layer.style) / 2,
                  color: seconBorderColor,
                  opacity: 1
                })
  
                _layer = L.layerGroup([_layer, polygonBorders]) // объединяем имеющийся слой и границы в группу, чтобы они включались и отключались вместе
              }


              layersWithNamesPolygons.push({layer: _layer, title: element.title, fillColor: element.fill, type: layer.style.type})
            })
          return layersWithNamesPolygons
    
          default:
            return null
        }
      } else {
        console.error('can\'t find features in layer', layer)
      }
      return null
    },
    
    addLeafLayerController (leafMap, baseLayersWithNames, imageLayersWithNames) {
      if (baseLayersWithNames === undefined || baseLayersWithNames === null || baseLayersWithNames.length <= 0) {
        return
      }
      let layersObj = {}
      
      for (let i = 0; i < baseLayersWithNames.length; i++) {
        if (baseLayersWithNames[i] !== undefined && baseLayersWithNames[i].title !== undefined) {
          layersObj[baseLayersWithNames[i].title] = baseLayersWithNames[i].layer
        }
      }

      
      let imageLayersObj = {}

      for (let i = 0; i < imageLayersWithNames.length; i++) {
        if (imageLayersWithNames[i] !== undefined && imageLayersWithNames[i].title !== undefined) {
          imageLayersObj[imageLayersWithNames[i].title] = imageLayersWithNames[i].layer
        }
      }

      L.control.layers(layersObj, imageLayersObj, { collapsed: true }).addTo(leafMap);

      
      /* let checkImageLayers = document.querySelectorAll('.leaflet-control-layers-overlays input')
      
      function checkOn() {
        for (let i = 0; i < checkImageLayers.length; ++i) {
          checkImageLayers[i].checked = true;
        }
      } */

      // checkOn()
    
      return leafMap
    },

    createLeafCustomLegend (leafMap, overlayLayersWithNames, blockId) {
      L.Control.LegendLikeEcharts = L.Control.extend({
        onAdd: function(map) {
          let wrapper = document.createElement('div') // обертка для контрола
          wrapper.id = "custom-legend-control"
          wrapper.classList = "custom-legend-control"
          for (let i = 0; i < overlayLayersWithNames.length; i++) { // добавляем получившиеся слои
            if (overlayLayersWithNames[i].title === undefined || overlayLayersWithNames[i].title === 'no-class') { // пропускаем тех что без title или те которым не нашелся класс
              continue
            }
            let row = document.createElement('div')
            row.classList = 'custom-legend-control__row'
            row.innerHTML = '<span>' + overlayLayersWithNames[i].title + '</span><div id="legend_' + blockId + '_' + i + '" class="custom-legend-control__row__marker" style="background-color:' + overlayLayersWithNames[i].fillColor + '"/>'
    
            row.addEventListener('click', function (e) {
              let id = `legend_${blockId}_${i}` // id цветного прямоугольника у слоя(маркера)
              let _marker = document.getElementById(id) // сам маркер
              if (map.hasLayer(overlayLayersWithNames[i].layer)) {
                map.removeLayer(overlayLayersWithNames[i].layer)
                _marker.style = 'background-color: transparent' // скрыть маркер
              } else {
                map.addLayer(overlayLayersWithNames[i].layer)
                _marker.style = `background-color: ${overlayLayersWithNames[i].fillColor}` // показать маркер
              }
            })
    
            wrapper.addEventListener('click', function (e) { // отключить зум на двойной клик
              event.stopPropagation()
            })
            wrapper.addEventListener('dblclick', function (e) { // отключить зум на двойной клик
              event.stopPropagation()
            })
            wrapper.appendChild(row)
          }
          return wrapper
        },
    
        onRemove: function (map) {
          console.log('remove')
        }
      })
    
      L.control.test = function(opts) {
        return new L.Control.LegendLikeEcharts(opts)
      }
    
      L.control.test({ position: 'bottomright' }).addTo(leafMap)
    },

    splitFeaturesByClassesLeaf (features, classColumn, style, sourceLayerIndex) { // Разделяет фичи по классам. Возвращает массив из объектов типа {title: 'class title', value: 'class value', fill: 'class fill color', geogson: [features]}
      let layersByClasses = [] // это будет просто набор данный
      for (let i = 0; i < features.features.length; i++) {
        features.features[i].properties._dataIndex = i // добавляем в properties _dataIndex, для того, чтобы привязать генерацию попапа к имеющейся
        features.features[i].properties._sourceLayerIndex = sourceLayerIndex // добавляем в properties _dataIndex, для того, чтобы привязать генерацию попапа к имеющейся

        let _index = layersByClasses.findIndex(item => { // если в layersByClasses уже есть элемент с value равным значению фичи, то добавляем в него фичу
          return item.value === features.features[i].properties[classColumn]
        })
        if (_index !== -1) {
          layersByClasses[_index].geojson.push(features.features[i])
        } else { // если в layersByClasses нет элемента с value равным значению фичи, то находим класс в стилях и создаем
          let _class = style.classes.find(item => {
            return item.value === features.features[i].properties[classColumn]
          })
          if (_class === undefined) { // если класс не нашелся, то заполняем переменню _class по своему усмотрению
            _class = {
              title: 'no-class',
              value: features.features[i].properties[classColumn],
              fill: this.baseMapStyles.defaultFill
            }
          }
          layersByClasses.push({
            title: _class.title,
            value: _class.value,
            fill: _class.fill,
            geojson: [features.features[i]]
          })
        }
      }
      return layersByClasses
    },

    addCustomTooltip (layer, titleColumn, color, title) {
      layer.bindTooltip( // Добавляем тултип
        function (leafLayer) {
          let wrapper = document.createElement('div')
          let name = document.createElement('div')
          name.innerText = leafLayer.feature.properties[titleColumn]
          let classNmaeWrapper = document.createElement('div')
          classNmaeWrapper.style = 'display: flex'
          let marker = document.createElement('div')
          marker.style = `display:block; border-radius:50%; margin-right: 6px; margin-top: 4px; width:12px; height:12px; background-color: ${color}`
          let className = document.createElement('div')
          className.style="display: block; text-align: left;"
          className.innerText = title === 'no-class' ? 'Нет класса': title.split(' ').join('\n')
          wrapper.appendChild(name)
          classNmaeWrapper.appendChild(marker)
          classNmaeWrapper.appendChild(className)
          wrapper.appendChild(classNmaeWrapper)
          return wrapper
        }, {
        sticky: true,
        className: 'custom-leaflet-tooltip',
        offset: [20, 60]
      })
    },

    onEachFeatureFunction (feature, layer, blockId) {
      layer.on({
        click: e => {
          L.DomEvent.stopPropagation(e) // останавливаем клик на feature(иначе он распространится на всю карту и тут же уничтожит попап)
          e.originalEvent.preventDefault()
          e.originalEvent.stopPropagation()
          let _e = {
            dataIndex: layer.feature.properties._dataIndex,
            sourceLayerIndex: layer.feature.properties._sourceLayerIndex,
            event: {
              event: {
                zrX: e.containerPoint.x,
                zrY: e.containerPoint.y
              }
            }
          }
          let _popup = this.createPopup(_e, blockId)
          document.getElementById(blockId).appendChild(_popup)
          this.$emit('changeStyleButtonGoChild', {dataIndex: _e.dataIndex, blockId: blockId, sourceLayerIndex: _e.sourceLayerIndex})
          return false
        }
      })
    },

    addOnEachFeatureHoverStyle (feature, layer) {
      layer.on('mouseover', function (e) {
        let _weight = 1
        if ('style' in layer.defaultOptions && 'weight' in layer.defaultOptions.style) { // у полигонов и точек дефолтные стили лежат в разных местах
          _weight = layer.defaultOptions.style.weight
        } else if ('weight' in layer.defaultOptions) {
          _weight = layer.defaultOptions.weight
        }
        layer.setStyle({
          fillColor: '#ffdf33',
          weight: _weight + 2
        })
        if ('radius' in layer.options) {
          layer.bringToFront()
        }
      })
    },

    addPointsBorder (leafMap, overlayLayersWithNames) {
      let svg = leafMap.getContainer().getElementsByTagName('svg')[0]
      let defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs')
      let borderRules = ''
      for (let i = 0; i < overlayLayersWithNames.length; i++) {
        if (overlayLayersWithNames[i].type === 'points') {
          borderRules += this.createPointBorderRule(overlayLayersWithNames[i])
        }
      }
      // defs.innerHTML = '<radialGradient id="gradient"><stop offset="100%" stop-color="red"/><stop offset="100%" stop-color="green"/></radialGradient>'
      defs.innerHTML = borderRules
      svg.appendChild(defs)
    },

    createPointBorderRule (overlayLayer) {
      if (overlayLayer === undefined || overlayLayer === null || !('borderRuleName' in overlayLayer) || !('borderColor' in overlayLayer)) {
        return ''
      }
      let rule = ''
      if (Array.isArray(overlayLayer.borderColor)) { // если массив цветов
        rule = `<radialGradient id="${overlayLayer.borderRuleName}">`
        for (let i = 0; i < overlayLayer.borderColor.length; i++) {
          rule += `<stop offset="100%" stop-color="${overlayLayer.borderColor[i]}"/>`
        }
        rule += '</radialGradient>'
      } else {
        rule = `<radialGradient id="${overlayLayer.borderRuleName}"><stop offset="100%" stop-color="${overlayLayer.borderColor}"/></radialGradient>`
      }
      return rule
    },

    convertPolygonsToPolyline (features) { // меняет координаты местами
      let _newFeatures = JSON.parse(JSON.stringify(features)) // создаем новую переменную, чтобы не изменять изначальные данные
      for (let i = 0; i < _newFeatures.length; i++) {
        if (_newFeatures[i].geometry.type === 'MultiPolygon') {
          for (let j = 0; j < _newFeatures[i].geometry.coordinates.length; j++) {
            for (let ij = 0; ij < _newFeatures[i].geometry.coordinates[j].length; ij++) {
              _newFeatures[i].geometry.coordinates[j][ij] = _newFeatures[i].geometry.coordinates[j][ij].map(item => {
                return [item[1], item[0]]
              })
            }
          }
        } else if (_newFeatures[i].geometry.type === 'Polygon') {
          for (let j = 0; j < _newFeatures[i].geometry.coordinates.length; j++) {
            _newFeatures[i].geometry.coordinates[j] = _newFeatures[i].geometry.coordinates[j].map(item => {
              return [item[1], item[0]]
            })
          }
        } else {
          console.error('fail create borders')
        }
      }

      return _newFeatures
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/chartMapMix.js